import {
    Card,
    Page,
    Text,
    Badge,
    Button,
    Divider
} from '@shopify/polaris';
import React, { Component } from 'react';
import { SkeletonPageCustom } from './SkeletonPageCustom';
import '../modern.css';

export class Plans extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            data: null
        };
    }

    componentDidMount() {
        this.populateData();
    }

    async populateData() {
        const response = await fetch('api/home/SubscriptionPlans');
        const data = await response.json();
        this.setState({ data, isLoading: false });
    }

    activatePlan = (isAnnual) => {
        const navUrl =
            'https://stickyaddtocartbar.azurewebsites.net/Account/ActivatePlan?shop=' +
            this.props.common.shopName +
            `&isAnnualPlan=${isAnnual}`;
        window.open(navUrl, '_top');
    };

    activateFree = () => {
        const navUrl =
            'https://stickyaddtocartbar.azurewebsites.net/Account/ActivatePlan?shop=' +
            this.props.common.shopName +
            '&isFreePlan=true';
        window.open(navUrl, '_top');
    };

    render() {
        if (this.state.isLoading) return <SkeletonPageCustom />;

        const { data } = this.state;

        const isFreePlanActivated = this.props.common.hasFreePlanActivated;

        const isMonthlyPlanActivated =
            !this.props.common.hasNotPickedPlan &&
            !this.props.common.hasTrialPlan &&
            !this.props.common.hasAnnualPlanActivated &&
            this.props.common.hasMonthlyPlanActivated;

        const isAnnualPlanActivated =
            !this.props.common.hasTrialPlan &&
            this.props.common.hasAnnualPlanActivated;

        const featureList = [
            'Sticky add to cart bar',
            'NEW: Countdown timer urgency bar',
            'Floating sticky cart icons',
            'Sticky cart & Sticky checkout bars',
            'Quick view, quick buy, & Buy now buttons',
            'Slider cart drawer w/ in cart upsell',
        ];
        const isMobile = window.innerWidth < 768;
        return (
            <Page title="Choose your plan">
                <div className="modern-onboarding" style={{ maxWidth: '1000px' }}>

                    <div
                        style={{
                            display: 'flex',
                            gap: 20,
                            flexWrap: 'wrap',
                            justifyContent: 'flex-start',
                            alignItems: 'stretch'
                        }}
                    >

                        {/* BASIC PLAN */}
                        <div
                            style={{
                                flex: '1 1 420px',
                                minWidth: 0,
                                display: 'flex'
                            }}
                        >
                            <Card sectioned>
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        height: '100%'
                                    }}
                                >

                                    <Text variant="headingMd">
                                        Shopify {this.props.common.planDisplayName} : monthly
                                    </Text>

                                    <div style={{ marginTop: 10 }}>
                                        <Text variant="headingLg">
                                            ${data.monthlyPlanPrice}/mo
                                        </Text>

                                        {isMonthlyPlanActivated && (
                                            <div style={{ margin: '10px 0px' }}>
                                                <Badge status="success">Current Plan</Badge>
                                            </div>
                                        )}

                                        {data.trialDays > 0 && (
                                            <Text>
                                                After {data.trialDays}-day free trial
                                            </Text>
                                        )}
                                    </div>

                                    <p style={{ margin: 6 }}></p>

                                    <Divider />

                                    <p style={{ margin: 6 }}></p>

                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'flex-start',
                                            gap: 20,
                                            flexWrap: 'wrap'
                                        }}
                                    >
                                        <div
                                            style={{
                                                flex: 1,
                                                display: 'flex',
                                                flexDirection: 'column'
                                            }}
                                        >
                                            <Text variant="headingSm">Features</Text>

                                            <div style={{ marginTop: 12 }}>
                                                {featureList.map((f, i) => (
                                                    <div key={i}>✓ {f}</div>
                                                ))}
                                            </div>

                                            <div>
                                                ✓ PRIORITY onboarding & support
                                            </div>

                                            <div
                                                style={{
                                                    // marginTop: 'auto',
                                                    // paddingTop: 24,
                                                    marginTop: isMonthlyPlanActivated || isMobile ? 30 :  isAnnualPlanActivated? 110 : 70 
                                                }}
                                            >
                                                <Button
                                                    primary
                                                    fullWidth
                                                    disabled={isMonthlyPlanActivated}
                                                    onClick={() => this.activatePlan(false)}
                                                >
                                                    {isMonthlyPlanActivated
                                                        ? 'Currently subscribed'
                                                        : data?.trialDays > 0
                                                            ? `Start ${data.trialDays}-day free trial`
                                                            : 'Select plan'}
                                                </Button>
                                            </div>
                                        </div>

                                        <div
                                            style={{
                                                width: '100%',
                                                maxWidth: 100,
                                                margin: '0 auto'
                                            }}
                                        >
                                            <img
                                                src="/images/STKY-LogoIcon.png"
                                                style={{ width: '100%' }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        </div>

                        {/* PREMIUM PLAN */}
                        <div
                            style={{
                                flex: '1 1 420px',
                                minWidth: 0,
                                display: 'flex'
                            }}
                        >
                            <div
                                style={{
                                    border: '2px solid #008060',
                                    borderRadius: 12,
                                    width: '100%'
                                }}
                            >

                                <div
                                    style={{
                                        background: '#008060',
                                        color: '#fff',
                                        textAlign: 'center',
                                        padding: 6,
                                        fontWeight: 600,
                                        borderRadius: 6
                                    }}
                                >
                                    Save {(this.props.common.shopName == "5caf43-11.myshopify.com" ? '58% ' : '30% ')} annually
                                </div>

                                <Card sectioned>
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            height: '100%'
                                        }}
                                    >

                                        <Text variant="headingMd">
                                            Shopify {this.props.common.planDisplayName} : annually
                                        </Text>

                                        <div style={{ marginTop: 10 }}>
                                            <Text variant="headingLg">
                                                ${(this.props.common.shopName == "5caf43-11.myshopify.com"? 5 : data.annualPlanPrice / 12).toFixed(2)}/mo
                                            </Text>

                                            {isAnnualPlanActivated && (
                                                <div style={{ margin: '10px 0px' }}>
                                                    <Badge status="success">
                                                        Current Plan
                                                    </Badge>
                                                </div>
                                            )}

                                            <Text color="success">
                                                Save  
                                                {(this.props.common.shopName == "5caf43-11.myshopify.com" ? '58% ' : '30% ')}
                                                annually
                                            </Text>

                                            {data.trialDays > 0 && (
                                                <Text>
                                                    After {data.trialDays}-day free trial
                                                </Text>
                                            )}

                                            {data.trialDays <= 0 && (
                                                <p style={{ marginTop: '20px' }}></p>
                                            )}
                                        </div>

                                        <p style={{ margin: 6 }}></p>

                                        <Divider />

                                        <p style={{ margin: 6 }}></p>

                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'flex-start',
                                                gap: 20,
                                                flexWrap: 'wrap'
                                            }}
                                        >
                                            <div
                                                style={{
                                                    flex: 1,
                                                    display: 'flex',
                                                    flexDirection: 'column'
                                                }}
                                            >
                                                <Text variant="headingSm">Features</Text>

                                                <div style={{ marginTop: 12 }}>
                                                    {featureList.map((f, i) => (
                                                        <div key={i}>✓ {f}</div>
                                                    ))}
                                                </div>

                                                <div>
                                                    ✓ PRIORITY onboarding & support
                                                </div>

                                                <div
                                                    style={{
                                                        marginTop: 'auto',
                                                        paddingTop: 24
                                                    }}
                                                >
                                                    <Button
                                                        primary
                                                        fullWidth
                                                        disabled={isAnnualPlanActivated}
                                                        onClick={() => this.activatePlan(true)}
                                                    >
                                                        {isAnnualPlanActivated
                                                            ? 'Currently subscribed'
                                                            : data?.trialDays > 0
                                                                ? `Start ${data.trialDays}-day free trial`
                                                                : 'Select plan'}
                                                    </Button>
                                                </div>
                                            </div>

                                            <div
                                                style={{
                                                    width: '100%',
                                                    maxWidth: 140,
                                                    margin: '0 auto'
                                                }}
                                            >
                                                <img
                                                    src="/images/STKY-BestValue.png"
                                                    style={{ width: '100%' }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </Card>
                            </div>
                        </div>
                    </div>

                    {/* FREE PLAN */}
                    <div
                        style={{
                            marginTop: 30,
                            marginBottom: 30,
                            border: '1px solid #DFE3E8',
                            borderRadius: 8,
                            padding: '16px 20px',
                            background: '#F9FAFB'
                        }}
                    >
                        <Text variant="headingSm">Free Plan</Text>

                        <Divider />

                        <div style={{ marginTop: 12 }}>
                            ✓ UP TO 25 ADD TO CARTS ONLY per month
                            <br />
                            ✓ With "Powered By STKY Add To Cart" Branding
                        </div>

                        <div style={{ marginTop: 8 }}>
                            <b>
                                STKY features will pause automatically after 25 clicks are reached.
                                Count will reset and unpause every 30 days.
                            </b>
                        </div>

                        <div style={{ marginTop: 8 }}>
                            {isFreePlanActivated ? (
                                <Badge status="success">
                                    Currently subscribed
                                </Badge>
                            ) : (
                                <span
                                    onClick={this.activateFree}
                                    style={{
                                        color: '#005BD3',
                                        cursor: 'pointer',
                                        textDecoration: 'underline'
                                    }}
                                >
                                    Choose free plan
                                </span>
                            )}
                        </div>
                    </div>

                </div>
            </Page>
        );
    }
}